<!--
  Custom Liga-Dropdown mit echten SVG-Flaggen statt nativem <select> - native Select-Elemente
  können keine Bilder in ihren Optionen darstellen (browserübergreifend nicht zuverlässig).
  Trigger-Button + teleportierte Liste, analog zum KalenderPopover-Muster in SpielplanWidget.vue.
-->
<template>
  <button
    type="button"
    class="tm-liga-dropdown__trigger"
    ref="triggerRef"
    aria-label="Liga-Filter"
    @click="$emit('toggle')"
  >
    <img v-if="ausgewaehlteLiga?.flaggeBild" :src="ausgewaehlteLiga.flaggeBild" class="tm-liga-dropdown__flagge" alt="" />
    <span class="tm-liga-dropdown__label">{{ ausgewaehlteLiga?.label ?? 'Alle' }}</span>
    <svg class="tm-liga-dropdown__pfeil" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path d="M5 8l5 5 5-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>
</template>

<script setup>
import { computed, ref } from 'vue'

const props = defineProps({
  ligen: { type: Array, required: true }, // [{ id, label, ligaId, flaggeBild }, ...]
  modelValue: { type: String, required: true } // aktuell gewählte liga.id
})
defineEmits(['toggle'])

const triggerRef = ref(null)
defineExpose({ triggerRef }) // damit die Elternkomponente die Position fürs teleportierte Panel berechnen kann

const ausgewaehlteLiga = computed(() => props.ligen.find(l => l.id === props.modelValue))
</script>